import { render, staticRenderFns } from "./Summarycard.vue?vue&type=template&id=7c31253c&"
import script from "./Summarycard.vue?vue&type=script&lang=js&"
export * from "./Summarycard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports